var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('header-campaign'),_c('list-campaign'),(_vm.dialogCampaign)?_c('form-campaign'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }